import React, { useContext } from 'react';
import { ConfigContext } from '../../../../Contexts/ConfigContext';
import CheckBoxInput from '../../../../Components/CheckBoxInput';
import PageHeading from '../../../../Components/PageHeading';
//mui imports====
import useCommonStyles from '../../../../commonStyles';
import { Grid, Paper } from '@mui/material';
import ArrayInputConfig from '../../../../Components/ArrayInputConfig';
//===============

const BackFillVastsConfig = ({ keyData , featureDescription}) => {
	const commonStyleClasses = useCommonStyles();
	const { rawConfig, updateRawConfig } = useContext(ConfigContext); //rawConfig from ConfigContext
	return (
		<Paper className={commonStyleClasses.mainPagePaperMarginStyle}>
			<PageHeading
				headingName="Backfill Vasts"
				headingPath={['Dashboard', 'Framerate', 'Features Data', 'Backfill Vasts']}
				description="Manage Backfill Vasts Configuration"
				showInfoButton = {true}
				infoMessage={featureDescription}
			/>

			<Grid item xs={3} style={{ marginTop: '4rem' }}>
				<CheckBoxInput
					keyData={keyData + '.enabled'}
					label="enabled"
					disabled={false}
					defaultChecked={false}
					object={rawConfig}
					updateObject={updateRawConfig}
					containerStyles={{ width: 'fit-content', marginLeft: '5rem' }}
				/>
			</Grid>

			<Grid style={{ padding: '0 6rem', margin: '3rem', marginLeft: '-1rem' }}>
				<ArrayInputConfig
					label="VastTags"
					keyData={keyData + '.vastTags'}
					entireArrayEditable={!!rawConfig[keyData + '.enabled']}
					object={rawConfig}
					updateObject={updateRawConfig}
					inputGridStyle={{ display: 'flex' }}
				/>
			</Grid>
		</Paper>
	);
};

export default BackFillVastsConfig;
